import SubSections from '~/constants/vdp/subSections';
import { useFactoryUpgradesQuali } from '~/context/common/FactoryUpgradesQualiContext';
import { useGetVehicleId } from '~/context/vdp/VehicleContext';
import InfoSash from './InfoSash';

type OwnProps = { factoryUpgradesMsrp: number };

export default function FactoryUpgradesBadge({
  factoryUpgradesMsrp
}: OwnProps) {
  const { captureEngagement } = useFactoryUpgradesQuali();
  const vehicleId = useGetVehicleId();

  const badgeText = `$${factoryUpgradesMsrp.toLocaleString()} in factory upgrades`;
  const compactBadgeText = `$${factoryUpgradesMsrp.toLocaleString()} factory upgrades`;

  return (
    <InfoSash
      adobeId={null}
      analyticsDescription="factory upgrades"
      bgColor="bg-background-primary-subtle"
      compactText={compactBadgeText}
      leadingText="Includes:"
      onSashClick={() => captureEngagement(vehicleId)}
      section={SubSections.FactoryUpgrades}
      testId="factory-upgrades-badge"
      text={badgeText}
    />
  );
}
